export default "__VITE_ASSET__B51FG3UQ__"